import React from 'react';
import { useVerticalSearchModule } from '../../Modules';
import {
  VerticalSearchItemData,
  VerticalSearchItem,
  createVerticalSearchItem,
  isVerticalSearchItem,
  SearchItem,
} from '@benzinga/search-modules';
import { TokenData } from '../tokenize';
import { ExpressionModule, ExpressionSearchModule } from './ExpressionModules';

export interface VerticalExpressionData {
  leftOperand: 'Tickers.name';
  operator: 'object';
  rightOperand: { vertical_name: string };
}

export interface VerticalExpressionModule extends ExpressionModule<VerticalSearchItemData> {
  toTokenData: (item: SearchItem) => VerticalExpressionData | undefined;
  fromTokenData: (token: TokenData<unknown>) => VerticalSearchItem | undefined;
}

export const isVerticalExpressionData = (token: TokenData<unknown>): token is VerticalExpressionData => {
  return (
    token.leftOperand === 'Tickers.name' &&
    token.operator === 'object' &&
    typeof token.rightOperand === 'object' &&
    token.rightOperand != null &&
    'vertical_name' in token.rightOperand
  );
};

export const createVerticalExpressionModule = (): VerticalExpressionModule => {
  return {
    fromTokenData: token => {
      if (!isVerticalExpressionData(token)) return undefined;
      return createVerticalSearchItem(token.rightOperand.vertical_name);
    },
    toTokenData: item => {
      if (!isVerticalSearchItem(item)) return undefined;
      return {
        leftOperand: 'Tickers.name',
        operator: 'object',
        rightOperand: { vertical_name: item.data.verticalName },
      };
    },
  };
};

export const useVerticalExpressionSearchModule = (): ExpressionSearchModule => {
  const verticalModule = useVerticalSearchModule();
  return React.useMemo(() => ({ ...verticalModule, expression: createVerticalExpressionModule() }), [verticalModule]);
};
